import { registerPlugin } from '@capacitor/core';

export interface ScriveSignPresentOptions {
  url: string;
  bankIdReturnUrl?: string;
  successUrlPrefix?: string;
}

export interface ScriveSignPresentResult {
  outcome: 'success' | 'dismissed';
  url?: string;
}

export interface ScriveSignPlugin {
  present(options: ScriveSignPresentOptions): Promise<ScriveSignPresentResult>;
}

export const ScriveSign = registerPlugin<ScriveSignPlugin>('ScriveSign');

export const SCRIVE_SIGN_BANK_ID_RETURN_URL = 'se.bkr://sign-continue';
export const SCRIVE_SIGN_SUCCESS_URL_PREFIX = 'https://app.bkr.se/sign-return';

export function buildSignSuccessRedirectUrl(projectId: string, documentId: string) {
  const params = new URLSearchParams({
    projectId,
    documentId,
  });
  return `${SCRIVE_SIGN_SUCCESS_URL_PREFIX}?${params.toString()}`;
}
